import { useCallback, useContext, useEffect } from 'react'
import {
  translate as translateInternal,
  TranslationContext,
} from './TranslationsProvider/TranslationsProvider'

export type TFunction = (
  key: string,
  keywords?: string[],
  lang?: string
) => string

export type UseTranslations = () => {
  t: TFunction
  lang: string
  gridLocale: Record<string, any>
}

const checkContext = (translationContext) => {
  if (!translationContext?.lang) {
    throw new Error(
      "Translations Context not found. You can't use this hook outside 'TranslationsProvider'."
    )
  }

  if (!translationContext?.translations) {
    throw new Error(
      `Translations missing for this language '${translationContext.lang}'`
    )
  }
}

const useTranslations: UseTranslations = () => {
  const translationsContext = useContext(TranslationContext)

  useEffect(() => {
    checkContext(translationsContext)
  }, [translationsContext])

  const translate: TFunction = useCallback(
    (key, keywords, lang) => {
      const { translations, getTranslations } = translationsContext
      return translateInternal(key, keywords, {
        translations: lang
          ? (getTranslations?.(lang) ?? translations)
          : translations,
      })
    },
    [translationsContext]
  )

  return {
    t: translate,
    lang: translationsContext?.lang,
    gridLocale: translationsContext?.gridLocale,
  }
}

export default useTranslations
